import React from 'react';

const ClassManagement = ({ classes, onClassSelect }) => {
  const getClassLevelColor = (level) => {
    const colors = {
      1: 'bg-blue-100 text-blue-800',
      2: 'bg-green-100 text-green-800',
      3: 'bg-yellow-100 text-yellow-800',
      4: 'bg-purple-100 text-purple-800',
      5: 'bg-pink-100 text-pink-800',
      6: 'bg-red-100 text-red-800'
    };
    return colors[level] || 'bg-gray-100 text-gray-800';
  };

  const getElectiveInfo = (classLevel) => {
    if (classLevel >= 6) {
      return (
        <div className="mt-2">
          <div className="text-xs text-gray-600 mb-1">選修制度:</div>
          <div className="flex gap-1">
            <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded">
              X1選修
            </span>
            <span className="px-2 py-1 bg-indigo-100 text-indigo-800 text-xs rounded">
              X2選修
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="class-management">
      <div className="section-header">
        <h2>班級管理</h2>
        <p>管理所有班級信息，包括一般班級和Form 6選修班級</p>
      </div>

      <div className="classes-grid">
        {classes.map((classItem) => (
          <div 
            key={classItem.id} 
            className="class-card"
            onClick={() => onClassSelect(classItem)}
          >
            <div className="class-card-header">
              <div className="class-info">
                <h3 className="class-name">{classItem.class_name}</h3>
                <p className="class-id">班級編號: {classItem.class_id}</p>
              </div>
              <div className={`class-level ${getClassLevelColor(classItem.class_level)}`}>
                中{classItem.class_level}
              </div>
            </div>

            <div className="class-details">
              <div className="detail-item">
                <span className="detail-label">班主任:</span>
                <span className="detail-value">{classItem.class_master}</span>
              </div>
              
              <div className="detail-item">
                <span className="detail-label">班級類型:</span>
                <span className="detail-value">
                  {classItem.class_level >= 6 ? '選修班級' : '一般班級'}
                </span>
              </div>

              {getElectiveInfo(classItem.class_level)}
            </div>

            <div className="class-actions">
              <button className="action-btn primary">
                📅 查看時間表
              </button>
            </div>
          </div>
        ))}
      </div>

      {classes.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">🏫</div>
          <h3>暫無班級資料</h3>
          <p>請檢查資料庫連接或聯繫系統管理員</p>
        </div>
      )}
    </div>
  );
};

export default ClassManagement;
